<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
  >
    <estado-deuda-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-create>
</template>

<script>

import EstadoDeudaProvider from "../../../../providers/EstadoDeudaProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import EstadoDeudaForm from "../EstadoDeudaForm";


export default {
  name: "EstadoDeudaCreate",

  components: {EstadoDeudaForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'cobrox.estadoDeuda.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        nombre: '',
        inactiva: false,
        cancelaSaldos: false,
        cancelaSaldosHistorico: false,
        informarBCRA: false,
        rotacionBloqueada: false,
        noRota: false
      }
    }
  },

  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        EstadoDeudaProvider.createEstadoDeuda(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createEstadoDeuda)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }

  },
}
</script>

<style scoped>

</style>

